'use client';
import {
  InviteAsFriendFeature,
  SellerVerificationFeature,
  WithdrawalSuccessFeature,
} from '@features/items-withdrawal';
import { PickUpItemsFeature } from '@features/items-withdrawal/05-pickup-items/ui';
import { WithdrawalErrorFeature } from '@features/items-withdrawal/error/ui/error';
import { observer } from 'mobx-react-lite';
import React from 'react';

import { CardSellerInfoEntity, CardSellersWrapper } from '@/entities';
import { ModalContent, ModalWrapper } from '@/shared/ui';
import { useStore } from '@/store/context';

import styles from './items-withdrawal.module.scss';

export const ItemsWithdrawalWidget = observer(() => {
  const withdrawalStore = useStore()?.withdrawal;

  const currentIndex = withdrawalStore?.trades.findIndex(
    item => item.id === withdrawalStore?.selectedTrade,
  );
  const currentItem = withdrawalStore?.trades[currentIndex];

  const goPrev = () => {
    if (currentIndex > 0) {
      withdrawalStore?.setSelectedTrade(
        withdrawalStore?.trades[currentIndex - 1].id,
      );
    }
  };

  const goNext = () => {
    if (currentIndex < withdrawalStore?.trades.length - 1) {
      withdrawalStore?.setSelectedTrade(
        withdrawalStore?.trades[currentIndex + 1].id,
      );
    }
  };

  return (
    <ModalWrapper
      close={() => withdrawalStore?.setSelectedTrade(null)}
      isOpened={!!withdrawalStore?.selectedTrade}
      className={styles['modal']}
    >
      <ModalContent
        className={styles['container']}
        topRightSlot={
          <ModalContent.CloseButton
            onClick={() => withdrawalStore?.setSelectedTrade(null)}
          />
        }
      >
        {currentItem?.status === 'created' && <InviteAsFriendFeature />}
        {currentItem?.status === 'verification' && (
          <SellerVerificationFeature
            name={currentItem.linkedRobloxAccount.robloxAccountName}
          />
        )}
        {currentItem?.status === 'getItems' && (
          <PickUpItemsFeature trade={currentItem} />
        )}
        {currentItem?.status === 'error' && <WithdrawalErrorFeature />}
        {currentItem?.status === 'success' && <WithdrawalSuccessFeature />}
        <CardSellersWrapper>
          <CardSellerInfoEntity.NavigationButton
            direction={'prev'}
            disabled={currentIndex === 0}
            onClick={goPrev}
          />

          <CardSellerInfoEntity src={''} trade={currentItem} />

          <CardSellerInfoEntity.NavigationButton
            direction={'next'}
            disabled={currentIndex === withdrawalStore?.trades.length - 1}
            onClick={goNext}
          />
        </CardSellersWrapper>
      </ModalContent>
    </ModalWrapper>
  );
});
